export const FIELD_NAMES = {
  AGE_SECTION: 'ageSection',
  ANNUAL_INCOME: 'Annual income',
  COVER_TYPE: 'Cover type',
  FOR: 'for',
  LIVING_IN: 'Living in',
};

export const LEAD_CAPTURE_FIELDS = {
  EMAIL: 'email',
  NAME: 'name',
  PHONE: 'phone',
};

export const AGE_SECTION_FIELDS = {
  AGE: 'age',
  PARTNER_AGE: 'partnerAge',
  ...LEAD_CAPTURE_FIELDS,
};

const AGE_SECTION_FIELD_NAMES = [
  AGE_SECTION_FIELDS.AGE,
  AGE_SECTION_FIELDS.PARTNER_AGE,
  LEAD_CAPTURE_FIELDS.NAME,
  LEAD_CAPTURE_FIELDS.PHONE,
  LEAD_CAPTURE_FIELDS.EMAIL,
];

const FIRST_MODAL_FIELDS = [FIELD_NAMES.COVER_TYPE];
const SECOND_MODAL_FIELDS = [FIELD_NAMES.FOR];
const THIRD_MODAL_FIELDS = [FIELD_NAMES.LIVING_IN];
const FOURTH_MODAL_FIELDS = [FIELD_NAMES.AGE_SECTION, ...AGE_SECTION_FIELD_NAMES];
const FIFTH_MODAL_FIELDS = [FIELD_NAMES.ANNUAL_INCOME];

export const MODAL_FIELDS = [
  { fields: FIRST_MODAL_FIELDS, index: 0 },
  { fields: SECOND_MODAL_FIELDS, index: 1 },
  { fields: THIRD_MODAL_FIELDS, index: 2 },
  { fields: FOURTH_MODAL_FIELDS, index: 3 },
  { fields: FIFTH_MODAL_FIELDS, index: 4 },
];

export const FIND_COVER_BUTTON_TEXT = 'Find cover';

export const WIDGET_TITLES = {
  DESKTOP: 'I’m looking for …',
  MOBILE: 'Get a quote',
  MOBILE_SUBTITLE: 'Health cover type',
};

export const MIN_AGE = 16;
export const MAX_AGE = 120;

export const AGE_FIELD_ERROR_MESSAGES = {
  AGE: 'Enter your age',
  AGE_AND_PARTNER_AGE: 'Enter your age and your partner’s age',
  LEAD_CAPTURE: 'Invalid contact details',
  PARTNER_AGE: 'Enter your partner’s age',
};
